<template>
  <div class="time-info-container">
    <!-- <div class="lp-title">운영시간 정보</div> -->
      <div class="time-info-select">
        <!-- 체크박스 선택 옵션 버튼 -->
        <div class="box-sel">
          <div class="btn-sel"
               v-for="(name, idx) in ['평일 선택','주말 선택', '전체 선택', '선택 해제']"
               :key="'item-'+idx"
               @click="selChkopt(idx)">{{ name }}</div>
        </div>

        <!-- 요일 표시 -->
        <div class="week-day-group" style="padding:10px;">
          <div class="day-of-the-week" v-for="(day,idx) in bsnhour" :key="'day'+idx">
            <div :class="{ 'checked-box' : !!day.checked, 'not-checked-box' : !day.checked }" @click.stop.prevent="clickCheck(idx)">
              <i v-if="!!day.checked" class="material-icons checked-icon" @click.stop.prevent="clickCheck(idx)">check</i>
            </div>
            <span class="span-day">{{ day.name }}</span>
            <!-- 요일 해당 근무시간 내용 -->
            <div class="item-bsnhour" v-if="day.hours!=''">{{ day.hours }}</div>
          </div>
        </div>
      </div>

      <!-- 요일에 적용할 근무시간대 (오른편) -->
      <div class="time-info-options">
        <!-- 휴무 여부 -->
        <div class="time-info-options-item">
          <div :class="{ 'checked-box' : !!input_bsnhour.is_holiday, 'not-checked-box' : !input_bsnhour.is_holiday }" @click.stop.prevent="!!input_bsnhour.is_holiday ? input_bsnhour.is_holiday=false : input_bsnhour.is_holiday=true">
            <i v-if="!!input_bsnhour.is_holiday" class="material-icons checked-icon"
              @click.stop.prevent="!!input_bsnhour.is_holiday ? input_bsnhour.is_holiday=false : input_bsnhour.is_holiday=true">check</i>
          </div>
          <span class="span-option">휴무 여부</span>
        </div>
        <!-- 24시간 영업 -->
        <div class="time-info-options-item" v-if="input_bsnhour.is_holiday == false">
          <div :class="{ 'checked-box' : !!input_bsnhour.is_full, 'not-checked-box' : !input_bsnhour.is_full }" @click.stop.prevent="!!input_bsnhour.is_full ? input_bsnhour.is_full=false : input_bsnhour.is_full=true">
            <i v-if="!!input_bsnhour.is_full" class="material-icons checked-icon"
              @click.stop.prevent="!!input_bsnhour.is_full ? input_bsnhour.is_full=false : input_bsnhour.is_full=true">check</i>
          </div>
          <span class="span-option">24시간 영업</span>
        </div>
        <!-- 영업 시간 -->
        <div v-if="input_bsnhour.is_holiday == false && input_bsnhour.is_full == false" style="margin-top:20px;">
          <div style="margin-bottom:8px; color:#333; font-size: .9rem;">영업 시간</div>
          <div style="display:flex; align-items:center; padding-left:8px;">
            <span style="font-size:.9rem; color:#555; margin-right:20px;">시작</span>
            <lp-time-picker :time.sync="input_bsnhour.start_time"  style="height:36px;"></lp-time-picker>
          </div>
          <div style="display:flex; align-items:center; padding-left:8px;">
            <span style="font-size:.9rem; color:#555; margin-right:20px;">종료</span>
            <lp-time-picker :time.sync="input_bsnhour.end_time" style="height:36px;"></lp-time-picker>
          </div>
        </div>
        <!-- 브레이크 타임 -->
        <div v-if="input_bsnhour.is_holiday == false && input_bsnhour.is_full == false" style="margin-top:20px;">
          <div style="display: flex; align-items: center; margin-bottom:8px;">
            <div style="color:#333; font-size: .9rem;">브레이크 타임</div>
            <lp-check-bool :checkedVal.sync="input_bsnhour.unable_break" label="없음" style="margin-left:20px;"></lp-check-bool>
          </div>
          <div v-if="!input_bsnhour.unable_break">
            <div style="display:flex; align-items:center; padding-left:8px;">
              <span style="font-size:.9rem; color:#555; margin-right:20px;">시작</span>
              <lp-time-picker :time.sync="input_bsnhour.break_start" style="height:36px;"></lp-time-picker>
            </div>
            <div style="display:flex; align-items:center; padding-left:8px;">
              <span style="font-size:.9rem; color:#555; margin-right:20px;">종료</span>
              <lp-time-picker :time.sync="input_bsnhour.break_end" style="height:36px;"></lp-time-picker>
            </div>
          </div>
        </div>

        <!-- <div class="time-info-options-item" v-if="input_bsnhour.is_holiday == false && input_bsnhour.is_full == false">
          <span>영업시간</span><br>
          <span class="span-option">시작</span>
          <select v-model="input_bsnhour.bsn.start">
            <option v-for="time in times">{{ time.hour }}</option>
          </select>
          <span class="span-option" style="margin-left: 30px;">종료</span>
          <select v-model="input_bsnhour.bsn.end">
            <option v-for="time in times">{{ time.hour }}</option>
          </select>
        </div> -->
        <!-- <button style="float:right;margin-top:20px" @click="setData">적용하기</button> -->
        <div class="time-info-btn" @click="setData">
          적용하기
        </div>
      </div>

  </div>
</template>

<script>
  import moment from 'moment';
  moment.locale('ko');
  import LpSortDropDown from './../common/LpSortDropDown'
  import LpTimePicker from  './../common/LpTimePicker'
  import LpCheckBool from './../common/LpCheckBool'

  export default {
    props: ['bsnhour'],
    components: {
      LpSortDropDown, LpTimePicker, LpCheckBool
    },
    data () {
      return {
        input_bsnhour: {
          start_time: moment().format('HH:mm'),
          end_time: moment().format('HH:mm'),
          break_start: moment().format('HH:mm'),
          break_end: moment().format('HH:mm'),
          unable_break:true,
          is_holiday: false,
          is_full: false
        },
        times:[],
      }
    },
    created(){
      this.time();
    },
    methods: {
      time(){
        for(var i=0; i<=23; i++){
          var min = 0
          for(var j=0; j<2; j++){
            if(j===0)
              min = '00'
            else if(j===1)
              min = '30'

            var time = i.toString() + ':' + min
            this.times.push({'hour': time})
          }
        }
      },
      selChkopt (idx) {
        //평일 선택
        if(idx === 0) {
          for(var i=0; i<5; i++) this.bsnhour[i].checked = true;
          for(var j=5; j<8; j++) this.bsnhour[j].checked = false;
        }
        //휴일 선택
        else if(idx === 1) {
          for(var i=0; i<5; i++) this.bsnhour[i].checked = false;
          for(var j=5; j<7; j++) this.bsnhour[j].checked = true;
          this.bsnhour[7].checked = false;
        }
        //전체 선택
        else if(idx == 2) {
          for(var x=0; x<8; x++) this.bsnhour[x].checked = true;
        }
        //선택 해제
        else {
          for(var y=0; y<8; y++) this.bsnhour[y].checked = false;
        }
      },
      clickCheck(index) {
        if ( this.bsnhour[index].checked === false ) {
          this.bsnhour[index].checked = true;
        }
        else if ( this.bsnhour[index].checked === true ) {
          this.bsnhour[index].checked = false;
        }
      },
      setData(){
        for(var i=0; i<this.bsnhour.length; i++) {
          if (this.bsnhour[i].checked) {
            var hours = '';
            var brk = '';

            this.bsnhour[i].is_holiday = this.input_bsnhour.is_holiday;
            this.bsnhour[i].is_full = this.input_bsnhour.is_full;
            this.bsnhour[i].start_time = this.input_bsnhour.start_time;
            this.bsnhour[i].end_time = this.input_bsnhour.end_time;
            this.bsnhour[i].break_start = this.input_bsnhour.break_start;
            this.bsnhour[i].break_end = this.input_bsnhour.break_end;

            if (this.input_bsnhour.is_holiday) hours = '휴무';
            else if (this.input_bsnhour.is_full) {
              hours = '24시간 영업';
              this.bsnhour[i].start_time='00:00';
              this.bsnhour[i].end_time='23:59';
            }
            else {
              var bsn_st = this.input_bsnhour.start_time;
              var bsn_end = this.input_bsnhour.end_time;
              hours = '영업시간: ' + bsn_st + ' ~ ' + bsn_end;

              this.bsnhour[i].start_time = bsn_st;
              this.bsnhour[i].end_time = bsn_end;

              if(this.input_bsnhour.unable_break === false) {
                var brk_st = this.input_bsnhour.break_start;
                var brk_end = this.input_bsnhour.break_end;
                brk = '브레이크타임: ' + brk_st + ' ~ ' + brk_end;
                this.bsnhour[i].break_start = brk_st;
                this.bsnhour[i].break_end = brk_end;
                this.bsnhour[i].unable_break = this.input_bsnhour.unable_break;
              }
            }

            this.bsnhour[i].hours = hours;
            if(brk!='')
              this.bsnhour[i].hours += '\n' + brk;
          }
        }
        this.$emit('update:value', this.input_bsnhour);

      },
      getData(){
        for(var i=0; i<this.bsnhour.length; i++) {
          var hours = '';
          var brk = '';

          if (this.bsnhour[i].is_holiday) hours = '휴무';
          else if (this.bsnhour[i].is_full) {
            hours = '24시간 영업';
            this.bsnhour[i].start_time = '00:00';
            this.bsnhour[i].end_time = '23:59';
          }
          else {
            var bsn_st = this.bsnhour[i].start_time;
            var bsn_end = this.bsnhour[i].end_time;
            hours = '영업시간: ' + bsn_st + ' ~ ' + bsn_end;

            if (this.bsnhour[i].unable_break === false) {
              var brk_st = this.input_bsnhour.break_start;
              var brk_end = this.input_bsnhour.break_end;
              brk = '브레이크타임: ' + brk_st + ' ~ ' + brk_end;
              this.bsnhour[i].break_start = brk_st;
              this.bsnhour[i].break_end = brk_end;
              this.bsnhour[i].unable_break = this.input_bsnhour.unable_break;
            }
          }

          this.bsnhour[i].hours = hours;
          if (brk != '')
            this.bsnhour[i].hours += '\n' + brk;
        }
      }
     /* setData () {
        for(var i=0; i<this.bsnhour.length; i++) {
          if (this.bsnhour[i].checked) {
            var hours = '';
            var brk = '';

            this.bsnhour[i].is_holiday = this.input_bsnhour.is_holiday;
            this.bsnhour[i].is_full = this.input_bsnhour.is_full;
            this.bsnhour[i].bsn = {start: '00:00', end: '00:00'};
            this.bsnhour[i].brk = {start: '00:00', end: '00:00'};

            if (this.input_bsnhour.is_holiday) hours = '휴무';
            else if (this.input_bsnhour.is_full) {
              hours = '24시간 영업';
              this.bsnhour[i].bsn = {start: '00:00', end: '23:59'};
            }
            else {
              var bsn_st = moment(this.input_bsnhour.bsn.start).format('HH:mm');
              var bsn_end = moment(this.input_bsnhour.bsn.end).format('HH:mm');
              hours = '영업시간: ' + bsn_st + ' ~ ' + bsn_end;

              this.bsnhour[i].bsn.start = bsn_st;
              this.bsnhour[i].bsn.end = bsn_end;

              if(this.input_bsnhour.unable_break == false) {
                var brk_st = moment(this.input_bsnhour.brk.start).format('HH:mm');
                var brk_end = moment(this.input_bsnhour.brk.end).format('HH:mm');
                brk = '브레이크타임: ' + brk_st + ' ~ ' + brk_end;
                this.bsnhour[i].brk.start = brk_st;
                this.bsnhour[i].brk.end = brk_end;
              }
            }

            this.bsnhour[i].hours = hours;
            if(brk!='')
              this.bsnhour[i].hours += '\n' + brk;
          }
        }
      }*/
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_variable'

  .time-info-container
    display flex

  .time-info-select
    width 480px

  .time-info-options
    width 400px
    border 1px solid #ddd
    padding 16px

  .time-info-options-item
    display flex
    align-items center
    margin-bottom 16px

  .box-sel
    margin-bottom 10px
    font-size 0.9em
    display flex
    color #333
    // max-width 260px
    // justify-content space-between

  .btn-sel
    border 1px solid #ddd
    border-radius 3px
    padding 7px
    width 80px
    text-align center
    margin-right 12px

  .day-of-the-week
    margin-bottom 12px
    display flex
    align-items center

  .span-day
    margin-left 5px
    color #555

  .span-option
    margin-left 5px
    color #333
    font-size .9rem

  .item-bsnhour
    border 1px solid #eee
    padding 5px
    margin-left 10px
    font-size 0.8em
    white-space pre-wrap

  .lp-title
    font-size 1.2rem
    padding-bottom 8px
    border-bottom 1px solid #c2c2c2
    margin-bottom 20px

  .checked-box
  .not-checked-box
    position relative
    width 16px
    height 16px
    border 2px solid #008fd9
    border-radius 3px
    margin-right 8px
    text-align center

  .checked-box
    background-color $primary

  .not-checked-box
    background-color #fff

  .checked-icon
    color #fff
    font-size .8rem
    font-weight bold
    position absolute
    left 0px
    top 0px

  .time-info-btn
    background $primary
    color #fff
    display inline-block
    padding 8px 20px
    border-radius 3px
    cursor pointer
    float right
    margin 20px 12px 0 0

  @media (max-width:440px)
    .time-info-container
      display block

    .time-info-btn
      float unset

    .time-info-options
      width 100%

    .btn-sel
      width 60px

    .item-bsnhour
      width 224px

    .btn-sel
    .day-of-the-week
      font-size 0.8rem
</style>
